import { TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { Title } from '@hh.ru/magritte-ui';

import EmptyStateIcon from 'src/widgets/GeoLocation/components/GeoLocationSearchEmptyState/empty-state-icon.svg';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.widgets.geo-location.search-empty-state.title',
    description: 'career-platform.widgets.geo-location.search-empty-state.description',
};

const GeoLocationSearchEmptyState: TranslatedComponent = ({ trls }) => (
    <div className={styles.container}>
        <EmptyStateIcon />
        <Title alignment="center" size="small" description={trls[TrlKeys.description]} Element="h6">
            {trls[TrlKeys.title]}
        </Title>
    </div>
);

export default translation(GeoLocationSearchEmptyState);
